import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import config from '../../config';

const ContestHelmet = ({ title, description, path, period, region }) => {
  const contestTitle = `${title} - Surfline`;
  const contestUrl = (baseHostType = 'local') => {
    const baseHost = baseHostType === 'seo' ? config.homepageSEOUrl : config.homepageUrl;
    const baseUrl = `${baseHost}${config.baseContestUrl(region, period)}`;
    return path ? `${baseUrl}${path}` : baseUrl;
  };

  const meta = [
    { name: 'description', content: description },
    { property: 'og:title', content: contestTitle },
    { property: 'og:url', content: contestUrl() },
    { property: 'og:image', content: config.meta.og.image },
    { property: 'og:description', content: description },
    { property: 'twitter:title', content: contestTitle },
    { property: 'twitter:url', content: contestUrl() },
    { property: 'twitter:image', content: config.meta.twitter.image },
    { property: 'twitter:description', content: description },
  ];

  if (config.robots) {
    meta.push({
      name: 'robots',
      content: config.robots,
    });
  }

  const link = [{ rel: 'canonical', href: contestUrl('seo') }];

  return (
    <Helmet
      title={contestTitle}
      meta={meta}
      link={link}
    />
  );
};

ContestHelmet.propTypes = {
  description: PropTypes.string.isRequired,
  path: PropTypes.string,
  period: PropTypes.string,
  region: PropTypes.string,
  title: PropTypes.string.isRequired,
};

ContestHelmet.defaultProps = {
  path: null,
  period: null,
  region: null,
};

export default ContestHelmet;
